// TODO: Use from existing routes constants after lib dependencies are cleaned up
export const JOBS_ROUTE = '/jobs';
